// Format a number as USD currency
export function formatCurrency(value) {
  if (value == null || isNaN(value)) return '--';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

// Format a number as a percentage string (e.g., 0.254 => "25.4%")
export function formatPercent(value) {
  if (value == null || isNaN(value)) return '--';
  return `${(value * 100).toFixed(1)}%`;
}

// Format a whole-number percentage (e.g., 25.4 => "25.4%")
export function formatPercentWhole(value) {
  if (value == null || isNaN(value)) return '--';
  return `${value.toFixed(1)}%`;
}
